export const en = {
  reports: {
    pageTitle: 'Reports',
    export: 'Export',
    tabs: {
      softSkills: 'Soft Skills',
      hardSkills: 'Hard Skills',
    },
    assessments: {
      pageTitle: 'Assessment Results',
      table: {
        firstName: 'First Name',
        lastName: 'Last Name',
        role: 'Role',
        department: 'Department',
        team: 'Team',
        completionStatus: 'Assessment Status',
        completionStatusOptions: {
          sent: 'Sent on {{timestamp}}',
          finished: 'Completed on {{timestamp}}',
        },
      },
      tutorial: {
        title: 'Browse reports',
        slides: {
          slide1: {
            title: 'Assessment Results',
            description:
              'Here you can find the table with the data from the latest completed assessment for each employee. The section is divided into two tabs: Soft Skills and Hard Skills, to analyze competencies by type.',
          },
          slide2: {
            title: 'Filter data',
            description:
              'Use the filters to segment the table by Department, Team, Role, and Completion Status. You can also filter by score range for each individual skill.',
          },
          slide3: {
            title: 'Export results',
            description:
              'Click Export to download the latest assessment data in Excel format. The Excel file is divided into two sheets: Soft Skills and Hard Skills. Each sheet contains one row per employee with First Name, Last Name, Role, Department, Team, and scores for each competency.',
          },
        },
      },
    },
    trainings: {
      pageTitle: 'Training usage',
      table: {
        firstName: 'First Name',
        lastName: 'Last Name',
        role: 'Role',
        department: 'Department',
        team: 'Team',
        trainingTime: 'Training Hours',
        trainingTimeTooltip:
          'The calculation of training hours includes the time spent on both completed and in-progress content',
        completedContents: 'Completed Contents',
        contentsInProgress: 'Contents in Progress',
      },
      alertBadge:
        'The analysis takes into account reading, video and quiz usage data for hard and soft skills collected over the last 12 months',
      exportBadge:
        'In the exported file you will find more details on the usage data for each individual training content',
      tutorial: {
        title: 'Browse reports',
        slides: {
          slide1: {
            title: 'Training usage',
            description:
              'Here you can find the table with hard and soft skills training content usage data per employee, calculated over the last 12 months.',
          },
          slide2: {
            title: 'Filter data',
            description:
              'Use the filters to segment the table by Department, Team, and Role. You can also filter by training hours completed, number of completed courses, and courses in progress.',
          },
          slide3: {
            title: 'Export results',
            description:
              'The Excel file is divided into two sheets: Employee Overview - Content Detail. The Overview sheet includes First Name, Last Name, Role, Department, Team, Training Hours, Completed Courses, and Courses in Progress for each employee. The Content Detail sheet shows the usage data for each training content.',
          },
        },
      },
    },
  },
};
